<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!taxGroup">
      <span class="loader"></span>
    </span>
    <div v-if="taxGroup" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="label"
      >
        <tab-pane title="label" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <tax-group-view-global
            :taxGroup="taxGroup"
            @onEditTaxGroup="editTaxGroup"
            @onDeleteTaxGroup="deleteTaxGroup"
          />
        </tab-pane>

        <tab-pane
          title="taxes"
          id="2"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_TAXES)"
        >
          <span slot="title">
            <i class="fa fa-percent"></i>
            {{ $t("TAXES.TAXES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <taxes-view :taxGroup="taxGroup" @needReload="get" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <tax-group-view-logs :taxGroup="taxGroup" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import TaxGroupViewLogs from "../partials/TaxGroupViewLogs.vue";
import TaxGroupViewGlobal from "../partials/TaxGroupViewGlobal.vue";
import TaxesView from "../partials/taxes/TaxesView.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    TaxGroupViewLogs,
    TaxGroupViewGlobal,
    TaxesView,
  },

  props: {
    taxGroupId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      taxGroup: null,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("taxGroups/get", this.taxGroupId);
        this.taxGroup = this.$store.getters["taxGroups/taxGroup"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    editTaxGroup(taxGroup) {
      this.$emit("onEditTaxGroup", taxGroup);
    },
    deleteTaxGroup(taxGroup) {
      this.$emit("onDeleteTaxGroup", taxGroup);
    },
  },
};
</script>
